import CustomerHierarchyActions from "./actions";

const INITIAL_STATE = {
  data: {},
  isProcessing: false,
  isError: false,
  errorMessage: [],
  form: {},
  isNewRecord: false,
  showModal: false,
  onSubmit: false,
  single: null,
  errorInternal: false,
  isErrorDelete: false,
};

function CustomerHierarchyReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case CustomerHierarchyActions.RESET_LIST:
      return {
        ...state,
        isProcessing: false,
        single: null,
        showModal:false,
        form: INITIAL_STATE.form,
        isNewRecord: true,
        data: {},
        isError: false,
      };
    case CustomerHierarchyActions.UPDATE_DATA:
      return {
        ...state,
        isProcessing: false,
        single: null,
        isNewRecord: false,
        isError: false,
      };
    case CustomerHierarchyActions.VIEW_DATA:
      return {
        ...state,
        isProcessing: false,
        single: action.payload,
        isNewRecord: false,
        showModal: true,
        isError: false,
      };
    case CustomerHierarchyActions.RESET_DATA:
      return {
        ...state,
        isProcessing: false,
        form: INITIAL_STATE.form,
        showModal: false,
      };
    case CustomerHierarchyActions.ON_SUBMIT:
      return { ...state, onSubmit: true, isError: false };
    case CustomerHierarchyActions.SHOW_DATA:
      return {
        ...state,
        isError: false,
        data: action.payload,
        errorMessage: [],
        isProcessing: false,
      };
    case CustomerHierarchyActions.SUCCESS_DATA:
      return {
        ...state,
        isError: false,
        showModal: false,
        form: INITIAL_STATE.form,
        onSubmit: false,
      };
    case CustomerHierarchyActions.PROCESS_DATA:
      return { ...state, isProcessing: true, isError: false, isSuccess: false };
    case CustomerHierarchyActions.ERROR_DATA:
      return {
        ...state,
        isError: true,
        onSubmit: false,
        errorMessage: action.payload,
        isProcessing: false,
      };
    case CustomerHierarchyActions.ERROR_SERVER:
      return {
        ...state,
        errorInternal: true,
        onSubmit: false,
        errorMessage: action.payload,
        isProcessing: false,
      };
    case CustomerHierarchyActions.ERROR_DELETE:
      return {
        ...state,
        isError: false,
        onSubmit: false,
        errorMessage: action.payload,
        isProcessing: false,
      };

    default:
      return state;
  }
}

export default CustomerHierarchyReducer;
